import React, { useRef } from "react";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import ReturnInvoiceViewTable from "./Componates/ReturnInvoiceViewTable";

const ReturnInvoiceView = () => {
  // Holds the handlePrintPDF function exposed by the child
  const printFnRef = useRef(null);

  const handlePrint = () => {
    if (printFnRef.current) printFnRef.current();
  };

  return (
    <PageBody
      card={false}
      padding="px-xl-5 px-lg-4 px-3 py-3"
      headerchildren={
        <>
          <HeadingOne>Return Invoice View</HeadingOne>
          <button className="btn btn-primary" onClick={handlePrint}>
            Print PDF
          </button>
        </>
      }
    >
      <div className="col-12">
        {/* Child exposes its print function via onPrintReady callback */}
        <ReturnInvoiceViewTable
          onPrintReady={(fn) => { printFnRef.current = fn; }}
        />
      </div>
    </PageBody>
  );
};

export default ReturnInvoiceView;
